import { render } from "./DetailViewEn.vue?vue&type=template&id=52f6a1d3"
import script from "./DetailViewEn.vue?vue&type=script&lang=js"
export * from "./DetailViewEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__